import { useWorkspace } from "../../../context/WorkspaceContext";
import { WorkspaceRole } from "../../../types";

export interface OrderTemplatePermissions {
  /** Owner/Administrator may create, edit, delete and pause/resume templates. */
  canManage: boolean;
  /**
   * Starting an order from a template needs order-create permission, matching
   * the backend (`create_order_draft` allows Owner/Administrator/OrderDraft).
   * ReadOnly members may view templates but not create orders from them.
   */
  canCreateOrder: boolean;
}

/**
 * Role-based capabilities for the order-templates feature, mirroring the
 * cloud-api authorization so the UI never offers an action that will fail
 * server-side.
 */
export const useOrderTemplatePermissions = (): OrderTemplatePermissions => {
  const { activeWorkspace } = useWorkspace();
  const role = activeWorkspace?.role;

  return {
    canManage:
      role === WorkspaceRole.Owner || role === WorkspaceRole.Administrator,
    canCreateOrder: !!role && role !== WorkspaceRole.ReadOnly,
  };
};
